var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Detail adresního místa")]),_c('Address',{attrs:{"address":_vm.address}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }